module.exports = __webpack_public_path__ + "static/media/fathom-icon.52fe6c44.png";